<template>
  <v-layout row wrap>
    <v-flex xs12 class="pt-0">
      <v-data-table
        :headers="headers"
        :items="listItems"
        :total-items="totalItems"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="ch-table-list"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"
              class="text-xs-left"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon v-if="sortableList.includes(header.value)">arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left list-btn" width="1%">
            <router-link
              :to="{ name: 'doorlocksDetailInfo', params: { id: props.item.id, hotel_id: props.item.hotel_id }}"
            ><i class="fas fa-search"></i></router-link>
          </td>
          <td class="text-xs-left" width="8%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.name }}</span><pre>{{ props.item.name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="6%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.type }}</span><pre>{{ props.item.type }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="5%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.dl_serial }}</span><pre>{{ props.item.dl_serial }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="8%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.hotel_name }}</span><pre>{{ props.item.hotel_name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="5%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.building_name }}</span><pre>{{ props.item.building_name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="5%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.floor_name }}</span><pre>{{ props.item.floor_name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="7%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.status }}</span><pre>{{ props.item.status }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="3%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.fw_version || '-'}}</span><pre>{{ props.item.fw_version || '-'}}</pre></v-tooltip></td>
          <td class="text-xs-left" v-if="rootDomainOnly" width="8%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.fw_type || '-'}}</span><pre>{{ props.item.fw_type || '-'}}</pre></v-tooltip></td>
          <td class="text-xs-left battery-item" width="7%">
            <span :class="props.item.battery_item"></span>
            <span :class="props.item.battery_item">{{ props.item.fw_battery ? `${props.item.fw_battery}%` : '-' }}</span>
          </td>
          <td class="text-xs-left" width="8%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.fw_logged_at | moment("YYYY-MM-DD HH:mm:ss") | '-' }}</span><pre>{{ props.item.fw_logged_at | '-'}}</pre></v-tooltip></td>
          <td class="text-xs-left" width="8%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.updated_at | moment("YYYY-MM-DD HH:mm:ss") | '-' }}</span><pre>{{ props.item.updated_at | '-'}}</pre></v-tooltip></td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import moment from 'moment';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { doorlocksEventBus } from '@/components/admin/doorlocks/doorlocksEventBus';
  import doorlockFormatter from '@/components/admin/doorlocks/doorlockFormatter';
  import api from '../../../api';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        // NOTE: first init
        isInit: false,
        // NOTE: Table List
        loading: false,
        searchCategory: null,
        search: null,
        pagination: {
          sortBy: null,
          descending: null,
          rowsPerPage: 20,
        },
        totalItems: 0,
        rootDomainOnly: false,
        headers: [
          { text: 'View', value: 'id', align: 'left', sortable: false },
          { text: 'Name', value: 'name', align: 'left' },
          { text: 'Type', value: 'type', align: 'left' },
          { text: 'Serial', value: 'dl_serial', align: 'left', sortable: false },
          { text: 'Hotel', value: 'hotel_name', align: 'left', sortable: false },
          { text: 'Building', value: 'building_name', align: 'left' },
          { text: 'Floor', value: 'floor_name', align: 'left' },
          { text: 'Status', value: 'status', align: 'left', sortable: false },
          { text: 'FW', value: 'fw_version', align: 'left', sortable: false },
          { text: 'Model', value: 'fw_type', align: 'left', sortable: false },
          { text: 'Battery', value: 'fw_battery', align: 'left' },
          { text: 'Battery Updated At', value: 'fw_logged_at', align: 'left' },
          { text: 'Updated At', value: 'updated_at', align: 'left' },
        ],
        rowsPerPageItems: [20, 50],
        sortableList: ['name', 'building_name', 'floor_name', 'fw_battery', 'fw_logged_at', 'updated_at'],
        // NOTE: Data
        listItems: [],
        filter: [],       // 쿼리문을 담을 배열
      };
    },
    methods: {
      /**
       * @description 상세 => 목록으로 넘어올 경우 필터값을 유지, 컴포넌트가 렌더링될 때 최초 한번만 실행
       */
      init() {
        if (_.isEmpty(this.storeFilter)) {
          this.getDoorlockList();
        }
      },
      getDoorlockList() {
        this.loading = true;
        const sortStr = this.pagination.sortBy;
        let orderStr = null;
        if (this.pagination.descending === null) {
          orderStr = null;
        } else if (this.pagination.descending === false) {
          orderStr = 'asc';
        } else if (this.pagination.descending === true) {
          orderStr = 'desc';
        }
        const querystring = {
          sort: sortStr,
          order: orderStr,
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          limit: this.pagination.rowsPerPage,
          pagination: true,
        };
        for (let index = 0; index < this.filter.length; index += 1) {
          querystring[this.filter[index].searchCategory] = this.filter[index].search;
        }
        api.getDoorlockList(querystring)
        .then((result) => {
          if (result.status === 200) {
            // console.log('result', result.data);
            this.totalItems = result.data.total;
            this.listItems = result.data.items.map((item) => {
              const rebuildItem = item;
              // NOTE: status string change
              switch (rebuildItem.status) {
                case 'created':
                  rebuildItem.status = 'Not installed';
                  break;
                case 'installed':
                  rebuildItem.status = 'Installed';
                  break;
                case 'updated':
                  rebuildItem.status = 'Need Update';
                  break;
                default:
                  rebuildItem.status = '';
                  break;
              }
              // NOTE: battery image
              if (rebuildItem.fw_battery === null) {
                rebuildItem.battery_item = 'battery-item__null';
              } else {
                if (rebuildItem.fw_battery >= 80) rebuildItem.battery_item = 'battery-item__good';
                if (rebuildItem.fw_battery < 80 && rebuildItem.fw_battery >= 30) rebuildItem.battery_item = 'battery-item__normal';
                if (rebuildItem.fw_battery < 30) rebuildItem.battery_item = 'battery-item__replace';
              }
              rebuildItem.type = doorlockFormatter.type(rebuildItem.type);
              rebuildItem.fw_type = rebuildItem.fw_type ? `${doorlockFormatter.fwType(rebuildItem.fw_type)}` : '-';
              return rebuildItem;
            });
            this.loading = false;
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      fromNow(datetime) {
        return moment(datetime).fromNow();
      },
      /**
       * @description 오름차순/내림차순 정렬
       */
      changeSort(column) {
        if (this.sortableList.includes(column)) {
          if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
          } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
          }
        }
      },
    },
    watch: {
      pagination: {
        deep: true,
        handler() {
          if (this.isInit) {
            console.log('handler');
            this.getDoorlockList();
          }
        },
      },
    },
    computed: {
      pages() {
        /* eslint max-len: ["error", { "code": 200 }] */
        return this.pagination.rowsPerPage ? Math.ceil(this.listItems.length / this.pagination.rowsPerPage) : 0;
      },
    },
    mounted() {
      console.log('doorlocklist mount');
      this.init();
      // NOTE: 페이지 로드
      this.$nextTick(() => {
        this.isInit = true;
      });
      this.$nextTick(() => {
        if (!_.isEmpty(this.storePage)) {
          this.pagination = Object.assign({}, this.storePage);
          this.getDoorlockList();
        }
      });
      if (localStorage.getItem('domain_type') === 'root') {
        this.rootDomainOnly = true;
      } else {
        const index = _.findIndex(this.headers, { text: 'Model' });
        this.headers.splice(index, 1);
      }
      doorlocksEventBus.$on('initFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        this.getDoorlockList();
      });
      doorlocksEventBus.$on('customFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        // NOTE: 검색조건이 바뀌므로 첫 페이지로 이동
        this.pagination.page = 1;
        this.getDoorlockList();
      });
      doorlocksEventBus.$on('reloadList', () => this.getDoorlockList());
    },
    updated() {
      storeFilterEventBus.$emit('setPage', this.pagination);
    },
  };
</script>

<style lang="scss" scoped>
.battery-item {
  span:nth-of-type(1) {
    // display: inline-block;
    // vertical-align: middle;

    // &.battery\-item__null {
    //   background-image: url('../../../assets/img/bat_gray.png');
    // }
    &.battery-item__good {
      display: inline-block;
      vertical-align: middle;
      width: 30px;
      height: 17px;
      background-image: url('../../../assets/img/bat_green.png');
    }
    &.battery-item__normal {
      display: inline-block;
      vertical-align: middle;
      width: 30px;
      height: 17px;
      background-image: url('../../../assets/img/bat_orange.png');
    }
    &.battery-item__replace {
      display: inline-block;
      vertical-align: middle;
      width: 30px;
      height: 17px;
      background-image: url('../../../assets/img/bat_red.png');
    }
  }
  span:nth-of-type(2) {
    &.battery\-item__null {
      color: #666666;
    }
    &.battery-item__good {
      color: green;
    }
    &.battery-item__normal {
      color: orange;
    }
    &.battery-item__replace {
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/doorlocks/DoorlocksList.vue